import {Button, Card} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpload} from "@fortawesome/free-solid-svg-icons";
import React, {useContext} from "react";
import {SoknaderContext} from "./contexts/SoknaderContext";

function SoknadCard(props:any){

    const {soknad, setSoknad, godkjenteKurs, errors} = useContext(SoknaderContext);
    const readOnly:boolean = props.readOnly;
    const showFileUpload = props.showFileUpload;

    return (
        <Card >
            <Card.Header className={"bg-primary card-header-ext"}>
                Søknad
            </Card.Header>
            <Card.Body>
                <div className="form-group row mb-2">
                    <label className="col-md-12 col-form-label col-form-label-sm">Velg fra forhåndsgodkjente kurs</label>
                    <div className="col-md-10">
                        <select
                            className="form-select form-select-sm"
                            disabled={readOnly}
                            onChange={(e: any) => {
                                const name=godkjenteKurs.filter((x:any)=> x.id===Number(e.target.value))[0]?.name??"";
                                setSoknad({...soknad, applicationDescription: name + "\n" + soknad.applicationDescription})
                            }}
                        >
                            <option></option>
                            {
                                godkjenteKurs.map((x: any) => {
                                    return <option key={x.id} value={x.id}>{x.name}</option>
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-12 col-form-label col-form-label-sm">Jeg søker refusjon / praksiskompensasjon for (kursnummer, navn og tilbyder /
                        annet)</label>
                    <div className="col-12">
                                <textarea
                                    className="form-control form-control-sm"
                                    rows={4}
                                    readOnly={readOnly}
                                    value={soknad?.applicationDescription}
                                    onChange={(e: any) => {
                                        setSoknad({...soknad, applicationDescription: e.target.value})
                                    }}
                                />
                        {errors?.applicationDescription && <span className={"validation-error"}>{errors.applicationDescription}</span>}
                    </div>
                </div>

                <div className="form-group row mb-2">
                    <label className="col-12 col-form-label col-form-label-sm">Beløp kursavgift
                        <span className={"text-muted form-control-sm"}
                              style={{fontStyle: "italic"}}>(maks kr 7.000)
                                </span>
                    </label>
                    <div className="col-md-2">
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.amountRefund}
                            onChange={(e: any) => {

                                setSoknad({...soknad, amountRefund: e.target.value===''?'': Math.round(e.target.value)})
                            }}
                        />
                        {errors?.amountRefund && <span className={"validation-error"}>{errors.amountRefund}</span>}
                    </div>
                    <div className={"col-10"}>
                        <Button className={"mt-1 mt-md-0"} disabled={readOnly || soknad.id===0}><FontAwesomeIcon icon={faUpload} onClick={showFileUpload}></FontAwesomeIcon></Button>
                        <span className={"text-muted form-control-sm"}
                              style={{fontStyle: "italic"}}>Last opp kursbevis og faktura</span>
                        { soknad.id===0?
                            <span className={"text-muted form-control-sm"}>Søknaden må lagres før du kan laste opp vedlegg</span>
                            :null
                            }
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className={"col-12 col-form-label col-form-label-sm"}>Jeg er ansatt i kommune og arbeidsgiver sender faktura separat</label>
                    <div className="col-md-10">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            disabled={readOnly}
                            checked={soknad?.privatePractice}
                            onChange={(e: any) => {
                                setSoknad({...soknad, privatePractice: e.target.checked})
                            }}
                        />
                    </div>
                </div>
                { soknad.privatePractice?
                    <div className="form-group row mb-2">
                        <label className="col-12 col-form-label col-form-label-sm">Beløp på faktura fra arbeidsgiver
                        </label>
                        <div className="col-md-2">
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                readOnly={readOnly}
                                value={soknad?.amountCompensation}
                                onChange={(e: any) => {
                                    setSoknad({ ...soknad, amountCompensation: e.target.value===''?'': Math.round(e.target.value) })
                                }}
                            />
                        </div>
                        <span style={{fontWeight: "bold", fontStyle: "italic"}}>Be arbeidsgiver merke faktura med
                                    "Formålsnummer 650499" og ditt navn, og sende faktura til
                                    receive@compello.com. Dersom det søkes om kursavgift som skal refunderes til deg, må ny søknad sendes inn for dette. Det må da ikke krysses av for ansatt i kommune.</span>
                    </div>:
                    <div className="form-group row mb-2">
                        <label className="col-12 col-form-label col-form-label-sm">Beløp praksiskompensasjon
                        </label>
                        <div className="col-md-2">
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                readOnly={readOnly}
                                value={soknad?.amountCompensation}
                                onChange={(e: any) => {
                                    setSoknad({ ...soknad, amountCompensation: e.target.value===''?'': Math.round(e.target.value) })
                                }}
                            />
                            {errors?.amountCompensation && <span className={"validation-error"}>{errors.amountCompensation}</span>}
                        </div>
                        <div className={"col-10"}>
                            <Button className={"mt-1 mt-md-0"} disabled={readOnly || soknad.id===0}><FontAwesomeIcon icon={faUpload} onClick={showFileUpload}></FontAwesomeIcon></Button>
                            <span className={"text-muted form-control-sm"}
                                  style={{fontStyle: "italic"}}>Last opp skjema for praksiskompensasjon</span>
                            { soknad.id===0?
                                <span className={"text-muted form-control-sm"}>Søknaden må lagres før du kan laste opp vedlegg</span>
                                :null
                            }
                        </div>
                        <p>Søknadsskjema for praksiskompensasjon finner du <a target={"_blank"} rel={"noreferrer"} href={"/pkomp2026.pdf"}>her</a></p>
                    </div>
                }
                { !soknad.privatePractice?
                <div className="form-group row mb-2">
                    <label className="col-12 col-form-label col-form-label-sm">Kontonummer for utbetaling</label>
                    <div className="col-md-2">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.accountNumber}
                            onChange={(e: any) => {
                                setSoknad({...soknad, accountNumber: e.target.value})
                            }}
                        />
                        {errors?.accountNumber && <span className={"validation-error"}>{errors.accountNumber}</span>}
                    </div>
                </div>
                    :null
                }
            </Card.Body>
        </Card>
    )
}

export default SoknadCard